import { useLayoutEffect, useRef, useState } from "react";

// Same mechanical flap the focus room uses, sized for marketing surfaces.
export default function SplitFlap({ value, label, className = "" }) {
  return (
    <div className={`split-flap-clock ${className}`} role="img" aria-label={label || value}>
      {String(value).split("").map((character, index) => character === ":"
        ? <span key={`separator-${index}`} className="split-flap-separator" aria-hidden="true">:</span>
        : <SplitFlapDigit key={`digit-${index}`} character={character} />)}
    </div>
  );
}

function SplitFlapDigit({ character }) {
  const previousCharacter = useRef(character);
  const [transition, setTransition] = useState(null);

  useLayoutEffect(() => {
    const from = previousCharacter.current;
    if (from === character) return undefined;
    previousCharacter.current = character;
    setTransition({ from, to: character });
    const timeout = window.setTimeout(() => setTransition(null), 440);
    return () => window.clearTimeout(timeout);
  }, [character]);

  return (
    <span className="split-flap-digit" aria-hidden="true">
      <span className="split-flap-half split-flap-top"><span>{character}</span></span>
      <span className="split-flap-half split-flap-bottom"><span>{transition?.from ?? character}</span></span>
      {transition && (
        <>
          <span key={`t-${transition.from}-${transition.to}`} className="split-flap-leaf split-flap-leaf-top"><span>{transition.from}</span></span>
          <span key={`b-${transition.from}-${transition.to}`} className="split-flap-leaf split-flap-leaf-bottom"><span>{transition.to}</span></span>
        </>
      )}
    </span>
  );
}
